import { Button } from '@material-ui/core';
import { ChevronRight } from '@material-ui/icons';

import { useTLang } from 'intl/intl';
import makeClasses from './ReasonsForContact.style';

export function ReasonsForContact(props: Props) {
  const { handleReasonSubstitution, handleReasonOther } = props;

  const lang = {
    title: useTLang({ id: 'order.detail.clientModule.reasons.title' }),
    reason: {
      substitution: useTLang({
        id: 'order.detail.clientModule.reasons.substitution',
      }),
      other: useTLang({ id: 'order.detail.clientModule.reasons.other' }),
    },
  };

  const _classes = makeClasses();

  return (
    <aside aria-label='reasons-for-contact' className={_classes.aside}>
      <h2 className={_classes.title}>{lang.title}</h2>
      <div>
        <Button
          fullWidth
          variant='text'
          classes={{ root: _classes.btn }}
          endIcon={<ChevronRight style={{ fontSize: '1.5rem' }} />}
          onClick={handleReasonSubstitution}
        >
          {lang.reason.substitution}
        </Button>
        <Button
          fullWidth
          variant='text'
          classes={{ root: _classes.btn }}
          endIcon={<ChevronRight style={{ fontSize: '1.5rem' }} />}
          onClick={handleReasonOther}
        >
          {lang.reason.other}
        </Button>
      </div>
    </aside>
  );
}

interface Props {
  handleReasonSubstitution(): void;
  handleReasonOther(): void;
}
